if (!customElements.get('variant-complementary-products')) {
  class VariantComplementaryProducts extends HTMLElement {
    connectedCallback() {
      this.sourceOptions = JSON.parse(this.dataset.sourceOptions || '[]');
      this.addEventListener('complementary:resolved', this.refreshSlides);
    }

    disconnectedCallback() {
      this.removeEventListener('complementary:resolved', this.refreshSlides);
    }

    updateFromSection(next, variant) {
      if (!next) return;
      this.sourceOptions = variant?.options || [];
      if (!variant) {
        this.hidden = true;
        return;
      }
      if (
        this.dataset.sourceProductId === next.dataset.sourceProductId &&
        this.dataset.sourceKey === next.dataset.sourceKey &&
        next.dataset.referenceKeys &&
        next.dataset.referenceKeys === this.dataset.referenceKeys &&
        (this.querySelector('[data-manual-color="true"]') || next.querySelector('[data-needs-color-resolution="true"]'))
      ) {
        this.querySelectorAll('card-variant-picker[data-locked-color]').forEach((picker) => {
          picker.matchLockedSource(this.sourceOptions);
        });
        this.hidden = !this.querySelector('[data-complementary-key]:not([hidden])');
        this.dataset.sourceVariantId = String(variant.id);
        this.dataset.sourceOptions = JSON.stringify(this.sourceOptions);
        return;
      }
      this.replaceContent(next);
    }

    replaceContent(next) {
      const open = this.querySelector('details')?.open;
      const focus = this.contains(document.activeElement) ? document.activeElement : null;
      const focusLabel = focus?.getAttribute('aria-label');
      Object.assign(this.dataset, next.dataset);
      this.hidden = next.hidden;
      this.innerHTML = next.innerHTML;
      const details = this.querySelector('details');
      if (details && open !== undefined) details.open = open;
      if (focusLabel) this.querySelector(`[aria-label="${CSS.escape(focusLabel)}"]`)?.focus({ preventScroll: true });
    }

    refreshSlides = () => {
      // A high-variant color can resolve to no available sizes. Compact the
      // existing Dawn slides so it cannot leave an empty carousel page behind.
      const cards = [...this.querySelectorAll('[data-complementary-key]:not([hidden])')];
      const pending = [...this.querySelectorAll('card-variant-picker[data-needs-color-resolution="true"]')].some((picker) => picker.busy);
      if (pending) return;
      this.hidden = !cards.length;
      if (this.hidden) return;
      const perPage = Number(this.dataset.productsPerPage);
      const slides = [...this.querySelectorAll('.complementary-slide')];
      slides.forEach((slide, index) => {
        const items = cards.slice(index * perPage, (index + 1) * perPage);
        slide.hidden = !items.length;
        const list = slide.querySelector('ul');
        if (items.length !== list.children.length || items.some((item, itemIndex) => list.children[itemIndex] !== item)) {
          list.replaceChildren(...items);
        }
      });
      const count = Math.ceil(cards.length / perPage);
      this.querySelectorAll('.slider-counter__link').forEach((link, index) => { link.hidden = index >= count; });
      const controls = this.querySelector('.slider-buttons');
      if (controls) controls.hidden = count < 2;
      this.querySelector('slideshow-component')?.resetPages();
    };
  }
  customElements.define('variant-complementary-products', VariantComplementaryProducts);
}
